import React, { Component } from "react";
import axios from "axios";
// Se eliminó el alias, ya que no era necesario
import { Divider, Space, Card, List, Tag, Typography, message, Row, Col, InputNumber, Input } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { dineroDisabledMask, Form, ModalItem, ButtonItem, round2Decimals,FormItem, InputItem, InputNumberItem } from "../../../../Components/Items";
// Asumo que tienes un componente similar para seleccionar insumos
import SelectInsumosItem from "../../../../Components/SelectInsumosItem";
import DiagramaConversion, {
  AZUL_BIWO,
  AZUL_BIWO_BG,
  LIMA_BIWO,
  LIMA_BIWO_BG,
} from "../../../../Components/DiagramaConversion";
import TablaEjemplosConversion from "../../../../Components/TablaEjemplosConversion";

const { Text } = Typography;

class AsignarInsumo extends Component {
    formRef = React.createRef();
    state = {
        clave: "",
        descripcion: "",
        descripcionLarga: "",
        costo: 0,
        impuestos: [],
        claveUnidad: "",
        loading: false,
        unidadInventarioTexto: "",
        calcProveedor: undefined,
        calcInventario: undefined,
        mostrarEjemploConversion: false,
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible && this.props.insumoIdPrecargado) {
            const idString = String(this.props.insumoIdPrecargado);
            this.consultarInsumo(idString);
            
            this.formRef.current.setFieldsValue({
                insumoId: idString
            });
        }
    }

    consultarInsumo = (insumoId) => {
        this.setState({ loading: true });
        axios
            .post(
                "insumos/datosVisualInsumo",
                { empresaId: this.props.empresaId, insumoId: insumoId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    const {
                        descripcion = "",
                        descripcionLarga = "",
                        clave = "",
                        costo = 0,
                        impuestos = [],
                        unidad,
                        unidadSat,
                    } = res.data.data || {};

                    const claveUnidad = unidadSat?.c_ClaveUnidad;
                    const unidadInventarioTexto = [unidadSat?.c_ClaveUnidad, unidad?.nombre]
                        .filter(Boolean)
                        .join(" - ");

                    this.setState({
                        descripcion,
                        descripcionLarga,
                        costo,
                        impuestos,
                        clave,
                        claveUnidad,
                        unidadInventarioTexto,
                        loading: false,
                    });

                    this.formRef.current.setFieldsValue({
                        descripcion,
                        costo,
                        claveUnidad,
                        codigo: clave,
                    });
                } else {
                    message.error("Insumo no encontrado");
                    this.setState({ loading: false });
                }
            })
            .catch(() => this.setState({ loading: false }));
    };

    onChangeInsumo = (insumoId) => {
        if (insumoId) {
            this.consultarInsumo(insumoId);
        } else {
            // Si se deselecciona, limpia el state y el formulario
            this.setState({
                clave: "",
                descripcion: "",
                descripcionLarga: "",
                costo: 0,
                impuestos: [],
                claveUnidad: "",
            });
            this.formRef.current.resetFields(['codigo', 'descripcion', 'claveUnidad', 'costo', 'conversion', 'compraMin']);
        }
    };

    cerrarModal = (nuevoInsumoRelacionado) => {
        this.setState({
            clave: "",
            descripcion: "",
            descripcionLarga: "",
            costo: 0,
            impuestos: [],
            claveUnidad: "",
            //loading: false,
        });
        if (this.formRef.current) {
            this.formRef.current.resetFields();
        }
        this.props.cerrarAsignarInsumo(nuevoInsumoRelacionado);
    };

    onFinish = (values) => {
        const { proveedor } = this.props;

        if (!proveedor?._id) {
            message.error("El proveedor no está definido. Cierre el modal y vuelva a intentarlo.");
            return;
        }

        if (values.insumoId) {
            this.setState({ loading: true });
            axios
                .post(
                    "insumos/asignarProveedor",
                    {
                        empresaId: this.props.empresaId,
                        proveedorId: proveedor._id,
                        ...values
                    },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    if (res.data.success === 2) {
                        this.setState({ loading: false });
                        this.cerrarModal(res.data?.nuevoInsumo);
                    } else {
                        message.error(res.data.message || "Error al asignar el insumo");
                        this.setState({ loading: false });
                    }
                })
                .catch(() => this.setState({ loading: false }));
        } else {
            message.error("Selecciona un insumo");
        }
    };

    onFinishFailed = (errorInfo) => {
        message.error("Complete los datos requeridos");
    };

    onChangeCalcConversion = () => {
        const proveedor = this.state.calcProveedor || 0;
        const inventario = this.state.calcInventario || 0;
        if (proveedor > 0) {
            this.formRef.current.setFieldsValue({
                conversion: parseFloat((inventario / proveedor).toFixed(4)),
            });
        }
    };

    setCalcProveedor = (valor) => {
        this.setState({ calcProveedor: valor }, this.onChangeCalcConversion);
    };

    setCalcInventario = (valor) => {
        this.setState({ calcInventario: valor }, this.onChangeCalcConversion);
    };

    switchMostrarEjemploConversion = () => {
        this.setState((prev) => ({ mostrarEjemploConversion: !prev.mostrarEjemploConversion }));
    };

    render() {
        const {
            descripcion,
            descripcionLarga,
            costo,
            impuestos,
            loading,
            clave,
            claveUnidad
        } = this.state;

        const { proveedor, visible, insumoIdPrecargado, insumoDataPrecargado } = this.props;
        return (
            <ModalItem
                title="Relacionar Insumo a Proveedor"
                visible={visible}
                onCancel={() => this.cerrarModal()}
                spinning={loading}
            >
                <Form
                    ref={this.formRef}
                    name="relacionarInsumo"
                    bottom={
                        <ButtonItem
                            type="primary"
                            htmlType="submit"
                            style={{ display: "block", margin: "0 0 0 auto" }}
                        >
                            Agregar Relación
                        </ButtonItem>
                    }
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Card size="small" style={{ marginBottom: 16, textAlign: 'center' }}>
                        <Text>Asignar insumo al proveedor: </Text>
                        <Text strong>{proveedor?.razonSocial || `${proveedor?.nombre} ${proveedor?.apellidoPaterno}`}</Text>
                    </Card>

                    <FormItem
                        label="Seleccionar Insumo"
                        name="insumoId"
                        required
                        margin
                    >
                        <SelectInsumosItem
                            empresaId={this.props.empresaId}
                            headersToken={this.props.headersToken}
                            onChange={this.onChangeInsumo}
                            tiposInsumos="proveedorSinRelacion"
                            proveedorId={proveedor?._id}
                            insumoPreCargado={
                                insumoDataPrecargado ? {
                                    _id: String(insumoIdPrecargado),
                                    stringBuscar: insumoDataPrecargado.descripcion || insumoDataPrecargado.leyenda
                                } : null
                            }
                        />
                    </FormItem>

                    <div className="asignar-table-card">
                        <table className="asignar-form-table">
                            <thead>
                                <tr>
                                    <th>Campo</th>
                                    <th>Insumo</th>
                                    <th>Relacion con Proveedor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="asignar-cell-label">Clave</td>
                                    <td className="asignar-cell-value">{clave}</td>
                                    <td>
                                        <FormItem name="codigo" required noStyle margin>
                                            <InputItem placeholder="Código del proveedor" />
                                        </FormItem>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="asignar-cell-label">Descripción</td>
                                    <td className="asignar-cell-value">{descripcion}</td>
                                    <td>
                                        <FormItem name="descripcion" required noStyle margin>
                                            <InputItem placeholder="Descripción del proveedor" />
                                        </FormItem>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="asignar-cell-label">Descripción Larga</td>
                                    <td className="asignar-cell-value asignar-prewrap">
                                        {descripcionLarga}
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className="asignar-cell-label">Unidad</td>
                                    <td className="asignar-cell-value">{claveUnidad}</td>
                                    <td>
                                        <FormItem name="claveUnidad" noStyle margin>
                                            <InputItem placeholder="Unidad del proveedor" />
                                        </FormItem>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="asignar-cell-label">Costo</td>
                                    <td className="asignar-cell-value">
                                        {dineroDisabledMask(costo)}
                                    </td>
                                    <td>
                                        <FormItem name="costo" required noStyle margin number>
                                            <InputNumberItem dinero placeholder="Costo del proveedor" />
                                        </FormItem>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="asignar-cell-label">Conversion</td>
                                    <td className="asignar-cell-value"></td>
                                    <td>
                                        <FormItem name="conversion" noStyle margin>
                                            <InputItem placeholder="Conversion"  disabled />
                                        </FormItem>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3} style={{ padding: 0, border: "none" }}>
                                        <FormItem
                                            shouldUpdate={(prev, curr) => prev.conversion !== curr.conversion || prev.claveUnidad !== curr.claveUnidad}
                                            noStyle
                                        >
                                            {({ getFieldValue }) => {
                                                const conversionRaw = parseFloat(getFieldValue("conversion"));
                                                const conversion = isNaN(conversionRaw) ? 1 : conversionRaw;
                                                const claveUnidadForm = getFieldValue("claveUnidad") || "unidad de compra";
                                                const unidadInventarioTexto = this.state.unidadInventarioTexto || "unidad de inventario";
                                                const { calcProveedor, calcInventario } = this.state;
                                                const tieneDatosBase = calcProveedor > 0 && calcInventario > 0;
                                                const proveedorGenerico = conversion >= 1 ? 1 : Math.round((1 / conversion) * 100) / 100;
                                                const inventarioGenerico = conversion >= 1 ? conversion : 1;

                                                return (
                                                    <Card size="small" style={{ margin: "8px 0 16px", backgroundColor: "#e6f7ff", borderColor: "#91d5ff" }}>
                                                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                                                            <Text strong style={{ color: "#1890ff", fontSize: 14 }}>
                                                                Ayuda para calcular conversión
                                                            </Text>
                                                            <EyeOutlined
                                                                onClick={this.switchMostrarEjemploConversion}
                                                                style={{
                                                                    cursor: "pointer",
                                                                    fontSize: 16,
                                                                    color: this.state.mostrarEjemploConversion ? "#1890ff" : "#91d5ff",
                                                                    transition: "color 0.3s",
                                                                }}
                                                                title="Ver ejemplos"
                                                            />
                                                        </div>
                                                        <Text type="secondary" style={{ fontSize: 12, display: "block", marginBottom: 12 }}>
                                                            Ingrese los valores con los que recibe el insumo de su proveedor y la cantidad en la que usted da de alta en su inventario.
                                                        </Text>
                                                        <Row gutter={16}>
                                                            <Col span={12}>
                                                                <div style={{ padding: 12, backgroundColor: "white", borderRadius: 4, border: "1px solid #d9d9d9", marginBottom: 8 }}>
                                                                    <Text strong style={{ display: "block", marginBottom: 8 }}>Proveedor</Text>
                                                                    <Input.Group compact>
                                                                        <InputNumber
                                                                            min={0}
                                                                            style={{ width: "30%" }}
                                                                            placeholder="Cantidad"
                                                                            value={calcProveedor}
                                                                            onChange={this.setCalcProveedor}
                                                                        />
                                                                        <Input
                                                                            value={claveUnidadForm}
                                                                            disabled
                                                                            style={{ width: "70%", backgroundColor: "#f5f5f5", textAlign: "center" }}
                                                                        />
                                                                    </Input.Group>
                                                                </div>
                                                                <div style={{ padding: 12, backgroundColor: "white", borderRadius: 4, border: "1px solid #d9d9d9" }}>
                                                                    <Text strong style={{ display: "block", marginBottom: 8 }}>Inventario</Text>
                                                                    <Input.Group compact>
                                                                        <InputNumber
                                                                            min={0}
                                                                            style={{ width: "30%" }}
                                                                            placeholder="Cantidad"
                                                                            value={calcInventario}
                                                                            onChange={this.setCalcInventario}
                                                                        />
                                                                        <Input
                                                                            value={unidadInventarioTexto}
                                                                            placeholder="Unidad"
                                                                            disabled
                                                                            style={{ width: "70%", backgroundColor: "#f5f5f5", textAlign: "center" }}
                                                                        />
                                                                    </Input.Group>
                                                                </div>
                                                            </Col>
                                                            <Col span={12}>
                                                                <div
                                                                    style={{
                                                                        padding: 12,
                                                                        backgroundColor: "white",
                                                                        borderRadius: 4,
                                                                        border: "1px solid #d9d9d9",
                                                                        height: "100%",
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        boxSizing: "border-box",
                                                                    }}
                                                                >
                                                                    <Text strong style={{ color: AZUL_BIWO, fontSize: 13, display: "block", marginBottom: 8 }}>
                                                                        Así se ve tu conversión
                                                                    </Text>
                                                                    <DiagramaConversion
                                                                        cajaA={{
                                                                            titulo: "El proveedor entrega",
                                                                            cantidad: tieneDatosBase ? calcProveedor : proveedorGenerico,
                                                                            unidad: claveUnidadForm,
                                                                            color: AZUL_BIWO,
                                                                            fondo: AZUL_BIWO_BG,
                                                                        }}
                                                                        cajaB={{
                                                                            titulo: "Das de alta en inventario",
                                                                            cantidad: tieneDatosBase ? calcInventario : inventarioGenerico,
                                                                            unidad: unidadInventarioTexto,
                                                                            color: LIMA_BIWO,
                                                                            fondo: LIMA_BIWO_BG,
                                                                        }}
                                                                        factorTexto={<>Factor: <strong>{conversion.toFixed(4)}</strong></>}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                );
                                            }}
                                        </FormItem>
                                        {this.state.mostrarEjemploConversion && <TablaEjemplosConversion />}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="asignar-cell-label">Compra Min.</td>
                                    <td className="asignar-cell-value">-</td>
                                    <td>
                                        <FormItem name="compraMin" noStyle margin>
                                            <InputItem placeholder="Compra Minima" />
                                        </FormItem>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <Divider plain>Impuestos configurados</Divider>
                    <Card size="small" bodyStyle={{ padding: 0 }}>
                        <List
                            dataSource={Array.isArray(impuestos) ? impuestos : []}
                            locale={{ emptyText: "Sin impuestos" }}
                            renderItem={(imp, idx) => {
                                let tagText = "";
                                if (imp.tasaCuota === 1) tagText = `Porcentual (base) ${imp.monto}%`;
                                else if (imp.tasaCuota === 2) tagText = `Porcentual (acumulado) ${imp.monto}%`;
                                else if (imp.tasaCuota === 3) tagText = `Monto fijo ${round2Decimals(imp.monto / (this.props.tipoDeCambio || 1))}`;
                                else if (imp.tasaCuota === 5) tagText = "Exento";
                                const nombre = imp.nombre || imp.clave || `Impuesto ${idx + 1}`;

                                return (
                                    <List.Item style={{ paddingLeft: 16, paddingRight: 16 }}>
                                        <Space>
                                            <Tag>{nombre}</Tag>
                                            <Text type="secondary">{tagText}</Text>
                                        </Space>
                                    </List.Item>
                                );
                            }}
                        />
                    </Card>
                </Form>
            </ModalItem>
        );
    }
}

export default AsignarInsumo;